import { render } from "./other.vue?vue&type=template&id=0ec18cc0&scoped=true"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"

import "./other.vue?vue&type=style&index=0&id=0ec18cc0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec18cc0"]])

export default __exports__